import { render, staticRenderFns } from "./PreparedContentsCategoryCard.vue?vue&type=template&id=8dd39a3e&scoped=true"
import script from "./PreparedContentsCategoryCard.vue?vue&type=script&lang=js"
export * from "./PreparedContentsCategoryCard.vue?vue&type=script&lang=js"
import style0 from "./PreparedContentsCategoryCard.vue?vue&type=style&index=0&id=8dd39a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd39a3e",
  null
  
)

export default component.exports